import warning from 'tiny-warning';

function deprecatedProp(validator, reason) {
  var warned = false;
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null && !props.__dangerouslySuppressWarning) {
      warning(warned, "The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason, "."));
      if (!warned) console.warn("".concat(componentNameSafe, ": props received =======>"), props);
      warned = true;
    }

    for (var _len = arguments.length, args = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(void 0, [props, propName, componentName, location, propFullName].concat(args));
  };
}

export { deprecatedProp };